import React from 'react';
import i18n from 'i18next';
import styles from './imageCreativeSizeHint.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const UrlRulesHint: React.FunctionComponent<{
  closeHint: () => void;
}> = ({ closeHint }) => {
  return (
    <div className={styles.imageCreativeSizeHint}>
      <div className={styles.title}>
        <span>{i18n.t<string>('urlRulesHint.labels.urlRulesInstruction')}</span>
        <FontAwesomeIcon icon={faTimes} onClick={closeHint} />
      </div>
      <div className='mt-4 p-4'>
        <div className='flex-column flex items-start'>
          <span className='mb-3 block text-[20px]'>
            mo 店+ 商家開放輸入下方形式連結
          </span>
          <ol className='w-full text-[16px]'>
            <li className='mb-2'>商店首頁</li>
            <div className='mb-3 text-wrap break-all text-xs'>
              (範例：https://www.momoshop.com.tw/TP/XXXXXXXXX/main)
            </div>
            <li className='mb-2'>商品列表頁</li>
            <div className='mb-3 text-wrap break-all text-xs'>
              (範例：https://www.momoshop.com.tw/TP/XXXXXXXXX/goods)
            </div>
            <li className='mb-2'>分類頁</li>
            <div className='mb-3 text-wrap break-all text-xs'>
              (範例：https://m.momoshop.com.tw/category.momo?cn=XXXXXXXXXXXX&entpCode=XXXXXXXXX)
            </div>
            <li className='mb-2'>商品詳情頁</li>
            <div className='mb-3 text-wrap break-all text-xs'>
              (範例：https://www.momoshop.com.tw/TP/XXXXXXXXX/goodsDetail/XXXXXXXXXXXXXXXX)
            </div>
          </ol>
        </div>
      </div>
    </div>
  );
};
